import React from "react";
import { Typography, Stack } from "@mui/material";
import WorkIcon from '@mui/icons-material/Work';
import { Career } from "./CareerSectionHelpers";
import useIsMobile from "../AppHelpers";

export interface CareerCardProps{
    career:Career
}

const CareerCard = (career:CareerCardProps)=> {
    const isMobile = useIsMobile()
    const getIcon = ()=>{
        return  <WorkIcon color="primary" fontSize='large'></WorkIcon>
    } 

    return (
  
        <Stack direction={'column'} sx={{backgroundColor:"antiqueWhite", textAlign:'left', padding:'2rem', width:'73vw', marginTop:'2rem'}}>
                <Stack direction={'row'} justifyItems={'center'}>
                    {getIcon()} 
                    <Stack sx={{marginLeft:'0.5rem'}}>
                        <Typography variant='h5' color="#420A02"> {career.career.jobTitle} </Typography>
                        <Typography variant="h6" color="#420A02"> {career.career.company} </Typography>
                    </Stack>
                    <Stack sx={{marginRight:0, marginLeft:'auto'}}>
                    <Typography variant="h6" color="#420A02"> {career.career.lengthOfService} </Typography>
                    </Stack>
              </Stack>
             {!isMobile && <Typography variant="body2" color="#420A02" fontFamily={'Helvetica Neue'} sx={{marginLeft:'2.5rem'}}> {career.career.briefDescription} </Typography>}
        </Stack>
    );
  }
   
  export default CareerCard;